<script setup lang="ts">
import ZZCMark from '@/views/header/ZZCMark.vue';
import CurrentUser from '@/views/header/CurrentUser.vue';
import {getAppVersion} from '@/base/frontendConfig.js';
import {onMounted, onUnmounted, ref} from 'vue';

// the header height is published as a css var so that sticky table headers can stick just below this header,
// whose height varies when the nav wraps on narrow screens
const headerRef = ref<HTMLElement>();
let resizeObserver: ResizeObserver | undefined;

onMounted(() => {
    resizeObserver = new ResizeObserver(() =>
        document.documentElement.style.setProperty('--mainheader-height', `${headerRef.value?.offsetHeight ?? 0}px`));
    resizeObserver.observe(headerRef.value!);
});

onUnmounted(() => resizeObserver?.disconnect());
</script>

<template>
    <header ref="headerRef" class="sticky bg-white top-0 z-40 border-b border-gray-300 shadow-sm" id="mainheader">
        <div class="flex flex-row items-stretch justify-between px-4">
            <div class="flex flex-row items-center py-2 shrink-0">
                <ZZCMark class="mr-3" :size="40"/>
                <div class="hidden lg:flex flex-col">
                    <span class="font-semibold text-zzc-blue leading-tight">Zeeuwse Zorgcoalitie</span>
                    <span class="text-xs text-gray-400 leading-tight cursor-default">{{ getAppVersion() }}</span>
                </div>
            </div>

            <nav class="flex flex-row flex-wrap items-end justify-center">
                <slot/>
            </nav>

            <div class="flex items-center shrink-0">
                <CurrentUser/>
            </div>
        </div>
    </header>
</template>
